import { Pagination as PaginationUI } from '@/components/ui';
import React, { memo } from 'react';

import { usePlayerListTemplate } from './context';
import { markSlot } from './slot-marker';

export type PlayerListTemplateV2PaginationProps = {
  /** Force hide the component even when there are multiple pages. */
  hidden?: boolean;
};

/**
 * Pagination slot — bound to `listLogic.paginatedMeta`. Hidden when there is
 * only a single page of results.
 */
function PaginationComponent({ hidden }: PlayerListTemplateV2PaginationProps) {
  const { listLogic } = usePlayerListTemplate();
  const totalPages = listLogic.paginatedMeta?.totalPages;
  const currentPage = listLogic.paginatedMeta?.page ?? 1;

  if (hidden) return null;
  if (!totalPages || totalPages <= 1) return null;

  return (
    <PaginationUI
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={listLogic.onChangePage}
    />
  );
}

const MemoPagination = memo(PaginationComponent);
MemoPagination.displayName = 'PlayerListTemplateV2.Pagination';

export const Pagination = markSlot(MemoPagination, 'pagination');
